import React from 'react'
import classNames from 'classnames'
import conviousLogo from 'images/convious-logo-pink.png'
import './permissionGroup.scss'

interface PermissionGroupProps {
    brandedTitle?: string
    children: React.ReactNode
    className?: string
    expanded?: boolean
}

export const PermissionGroup = ({ brandedTitle, children, className, expanded }: PermissionGroupProps) => (
    <div className={classNames('permission-group', className, { expanded })}>
        {brandedTitle && (
            <div className="permission-group-title">
                <img className="convious-logo" src={conviousLogo} alt="Convious" />
                <span>{brandedTitle}</span>
            </div>
        )}
        {children}
    </div>
)

interface PermissionGroupContentProps {
    children: React.ReactNode
    height?: number
}

export const PermissionGroupContent = ({ children, height }: PermissionGroupContentProps) => (
    <div className="permission-group-content" style={{ '--content-height': height } as React.CSSProperties}>
        {children}
    </div>
)
